<template>
  <div id="app">
    <header-el></header-el>
    <div class="user">
      <div class="user-left">
        <div
          class="img"
          style="background-image:url('http://images.kaishiba.com/1460023021000612.jpg')"
        ></div>
        <p class="mt80p">
          <!-- 造一座房子，住在水墨画里 -->
          一个房子，一个账号，即可踏浪
        </p>
        <div class="tc mt30p">
          <i class="icon-kaistart-arrows-right"></i>
        </div>
        <div class="tc mt40">
          <a class="color-black" href="javascript:;">马上登录</a>
        </div>
      </div>
      <div class="user-right">
        <form action="user/login" method="post" autocomplete="off">
          <div class="ksui-form mt60">
            <label>
              <span class="fs14 lh40 w100 tr mr20">
                <i class="color-red">*</i>账号
              </span>
              <input
                autocomplete="off"
                name="phone"
                class="fs14"
                placeholder="手机 / 邮箱"
                type="text"
                v-model="userlogin.LoginAccount"
              >
            </label>
            <p class="fs12 lh20 ml145 color-red hide">账号不存在</p>
          </div>
          <div class="ksui-form mt30">
            <label>
              <span class="fs14 lh40 w100 tr mr20">
                <i class="color-red">*</i>密码
              </span>
              <input
                autocomplete="off"
                name="password"
                class="fs14"
                placeholder="请输入密码"
                type="password"
                v-model="userlogin.LoginPassword"
              >
            </label>
          </div>
          <div class="tr mr105">
            <a
              href="javascript:;"
              class="color-999 mr20"
              name="loginwithphone"
              style="display: none;"
            >账号密码登录</a>
            <a href="javascript:;" class="color-999 mr20" name="loginwithphone">短信验证码登录</a>
            <a
              class="color-999"
              name="forgetpassword1"
              href="https://member.kaishiba.com/findpwd.html"
            >忘记登录密码</a>
          </div>
          <div class="login-other-ink">
            <hr>
            <i class="span-cercle">其它方式登录</i>
            <ul>
              <li class="webchat">
                <a href="#">
                  <i class="icon-kaistart-wechat"></i>
                </a>
                <div id="login_container">
                  
                </div>
              </li>
            </ul>
          </div>
          <div class="user-btnbox">
            <a class="ksui-btn" href="/reg">免费注册</a>
            <input class="ksui-btn-green" type="button" value="登录" v-on:click="login">
          </div>
        </form>
      </div>
    </div>
  </div>
</template>



<script>
import { mapState } from "vuex";
import Header from "../components/header";

export default {
  name: "app",
  components: {
    "header-el": Header
  },
  data() {
    return {
      userlogin: {}
    };
  },
  computed: {
    ...mapState({})
  },
  methods: {
    login: function() {
      this.$store.dispatch("myuser/login", {
        user: this.userlogin,
        router: this.$router
      });
    }
  }
};
</script>

<style scoped>
@import url("../css/login.css");
footer {
  display: none;
}
</style>
